import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { Button, Grid } from "@mui/material";
import { getLogin } from "redux/actions/UserLogin";
import { getRegistration } from "redux/actions/UserRegistration";

function Timer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [timerValue, setTimerValue] = useState(60); // Set an initial timer value
  const [isResendActive, setIsResendActive] = useState(false); // Set initial state of the resend button

  const signupDetails = JSON.parse(localStorage.getItem("signUpDetails"));
  const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
  const credentialsDetails = props?.pageType ? signupDetails : loginDetails;

  useEffect(() => {
    callIntervalFunction() // Clean up the interval on component unmount
  }, []);

  const callIntervalFunction = () => {
    const interval = setInterval(() => {
      setTimerValue((prevTimerValue) => {
        if (prevTimerValue === 1) {
          props?.setAutoFocusOtp(false);
          setIsResendActive(true); // Timer reached 0, enable the resend button
          clearInterval(interval); // Stop the timer
        }
        return prevTimerValue - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }


  const OnResend = () => {
    const platform = 'AdminApp'

    const loginPayload = {
      userDetails: {
      platform: platform,
      "mobileOrEmail": credentialsDetails?.mobile,
      "countryCode": credentialsDetails?.code
      },
      actionType: "resendOtp"
    }

    const signupPayload = {
      userDetails: {
        platform: platform,
        mobile: credentialsDetails?.mobile,
        email: credentialsDetails?.email,
        countryCode: credentialsDetails?.code,
        location: credentialsDetails?.location,
        companyName: credentialsDetails?.companyName,
        role:'subVendor'
      },
      actionType: "resendOtp"
    }
  
    // dispatchEvent(call redux function: action -> saga -> reducer (update the store)

    if(props?.pageType === "signupOtp") {
      dispatch(getRegistration(signupPayload, navigate));
    }
    else {
      dispatch(getLogin(loginPayload, navigate))
    }

    setIsResendActive(false)
    setTimerValue(60)
    callIntervalFunction();
    props?.onResend();
    props?.setAutoFocusOtp(true);
  }

  return (
    <div>
      <Grid
        container
        direction="row"
        alignItems="center"
        spacing={2}
      >
        <Grid item>
          {!isResendActive && <CountdownCircleTimer
            isPlaying
            size={50}
            strokeWidth={5}
            isGrowing="true"
            rotation="clockwise"
            duration={60}
            colors={["#0f538D"]}
          >
              {({ remainingTime }) => (
              <div className="colorPrimary">
                {remainingTime} <span className="font7">Sec</span>
              </div>
            )
            }
          </CountdownCircleTimer>}
        </Grid>

        <Grid item>
          <Button
            className={isResendActive ? "otpResend colorPrimary" : "otpResend colorGrey" }
            disabled={!isResendActive}
            sx={{ textDecoration: 'underline' }}
            onClick={() => OnResend()}
          >
            Resend
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default Timer;
